export default "/_nuxt/ed1e229918290bd37717d1b1336113fc.svg";